"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var omit = exports.omit = function omit(keys, obj) {
  return Object.keys(obj).reduce(function (acc, key) {
    if (keys.indexOf(key) === -1 && obj[key] !== undefined) {
      acc[key] = obj[key];
      return acc;
    }
    return acc;
  }, {});
};

var getComputedRowHeight = exports.getComputedRowHeight = function getComputedRowHeight(node, rows) {
  if (!rows) {
    return 0;
  }

  var _window$getComputedSt = window.getComputedStyle(node),
      lineHeight = _window$getComputedSt.lineHeight,
      paddingBottom = _window$getComputedSt.paddingBottom,
      paddingTop = _window$getComputedSt.paddingTop;

  return parseInt(lineHeight) * parseInt(rows) + parseInt(paddingBottom) + parseInt(paddingTop);
};

var getHeight = exports.getHeight = function getHeight(node, rows) {
  return Math.max(getComputedRowHeight(node, rows), node.scrollHeight);
};